import React, { FC, PropsWithChildren } from "react";
import styles from "./styles.module.css";
import { Link } from "react-router-dom";
import SVGAsset from "@/components/atoms/SVGAsset/SVGAsset";
import Text from "@/components/atoms/Text";

interface SidebarLayoutContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  padded?: boolean;
}

export const SidebarLayoutContainer: FC<PropsWithChildren<SidebarLayoutContainerProps>> = ({
  padded,
  className,
  children,
  ...rest
}) => {
  const classNames = [styles.sidebarLayoutContainer, padded ? styles.sidebarLayoutContainerPadded : null, className]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classNames} {...rest}>
      {children}
    </div>
  );
};
export const SidebarLayoutMenu: FC<PropsWithChildren> = (props) => (
  <div className={styles.sidebarLayoutMenu} {...props} />
);

interface SidebarLayoutContentProps extends React.HTMLAttributes<HTMLDivElement> {
  stretch?: boolean;
}
export const SidebarLayoutContent: FC<PropsWithChildren<SidebarLayoutContentProps>> = ({
  stretch,
  className,
  children,
  ...rest
}) => {
  const classNames = [styles.sidebarLayoutContent, stretch ? styles.sidebarLayoutContentStretched : null, className]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classNames} {...rest}>
      {children}
    </div>
  );
};

export const SidebarLayoutNavRoot: FC<PropsWithChildren> = (props) => (
  <nav className={styles.sidebarLayoutNavRoot} {...props} />
);
export interface SidebarLayoutNavItemProps {
  href: string;
  text: string;
  isActive?: boolean;
  icon: string;
  onMouseEnter?: () => void;
  onFocus?: () => void;
}

const SidebarLayoutNavItem: FC<PropsWithChildren<SidebarLayoutNavItemProps>> = ({
  href,
  text,
  isActive,
  icon,
  onMouseEnter,
  onFocus,
}) => {
  return (
    <li className={`${styles.sidebarLayoutNavItemRoot}`}>
      <Link
        to={href}
        className={`${styles.link} ${isActive ? styles.active : ""}`}
        onMouseEnter={onMouseEnter}
        onFocus={onFocus}
      >
        <SVGAsset name={icon} />
        <Text size="sm" span={true} display="technical" tt="uppercase" strong={true}>
          {text}
        </Text>
      </Link>
    </li>
  );
};

export default SidebarLayoutNavItem;
